import React, { ReactNode } from 'react';

import Box from '@material-ui/core/Box'
import makeStyles from '@material-ui/core/styles/makeStyles'

export type TextOverflowProps = {
  /**
   * a node to be rendered in the special component.
   */
  children?: ReactNode;
  /**
   * number of lines to display after line clamp.
   */
  lineClamp?: number
};

type StyleProps = {
  lineClamp: number
}

const useStyles = makeStyles({
  overFlow: {
    display: '-webkit-box',
    '-webkit-line-clamp': ({ lineClamp }: StyleProps) => lineClamp,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    wordBreak: 'break-word',
    textOverflow: 'ellipsis'
  }
})

export function TextOverflow({ children, lineClamp = 2, ...props }: TextOverflowProps) {
  const classes = useStyles({ lineClamp })
  return (
    <Box className={classes.overFlow} {...props}>
      {children}
    </Box>
  );
}
